import axios from "axios";

const GinIoTAPI = axios.create();

GinIoTAPI.defaults.baseURL = "https://iot-api-jin.sangsang.farm/v1";

export default GinIoTAPI;
